import React, { useEffect, useState } from 'react';
import './form.sass';
import {Input, InputSize} from '../../../../../components/interface/input/input';
import {Dropdown} from '../../../../../components/interface/input/dropdown/dropdown';
import {TextArea} from '../../../../../components/interface/input/textarea/textarea';
import {InputCheckbox} from '../../../../../components/interface/input/checkbox/input-checkbox';
import {Button, ButtonSize, ButtonType} from '../../../../../components/interface/button/button';
import * as Yup from 'yup';
import {useFormik} from 'formik';
import axios from 'axios';
import { toast } from 'react-toastify';

const FormsSchema = Yup.object().shape({
    companyName: Yup.string()
        .min(3, 'Za krótkie!')
        .max(50, 'Za długie!')
        .required('Pole wymagane!'),
    category: Yup.string().required('Pole wymagane!'),
    description: Yup.string().max(100, 'Za dużo!').required('Pole wymagane!'),
    city: Yup.string()
        .min(3, 'Za krótkie!')
        .max(30, 'Za długie!')
        .required('Pole wymagane!'),
    nip: Yup.string().matches('^\\d+$', 'Nip nieprawidłowy!')
        .min(10, 'Za krótkie!')
        .max(10, 'Za długie')
        .required('Pole wymagane!'),
    name: Yup.string()
        .min(6, 'Za krótkie!')
        .max(50, 'Za długie!')
        .required('Pole wymagane!'),
    email: Yup.string()
        .email('Email nieprawidłowy!')
        .required('Pole wymagane!'),
    marketingPermission: Yup.boolean().oneOf([true], 'Pole wymagane!'),
});

const options = {
    method: 'POST',
    url: 'https://api.viceversa.app/api/v1/vendor/apply',
    headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json'
    },
    data:{}
};

const categoriesOptions = {
    method: 'GET',
    url: 'https://api.viceversa.app/api/v1/vendor/categories',
    headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json'
    },
    data:{}
};


export const Form = ({scrollRef}) => {
    const [formSubmit, setFormSubmit] = useState(false);
    const [categories, setCategories] = useState([]);

    const getCategories = () => {
        axios.request(categoriesOptions)
            .then((data) => {
                setCategories(data.data);
            });
    };

    useState(() => {
        getCategories();
    });

    const formik = useFormik({
        initialValues: {
            companyName: '',
            category: {},
            description: '',
            city: '',
            nip: '',
            name: '',
            email: '',
            marketingPermission: false,
        },
        validationSchema: FormsSchema,
        onSubmit: (values) => {
            options.data = {
                companyName: values.companyName,
                category: values.category,
                description: values.description,
                city: values.city,
                nip: values.nip,
                name: values.name,
                email: values.email,
            };
            axios.request(options)
                .then(() => {
                    toast.success('Formularz wysłany');
                    setFormSubmit(true);
                }, () => {
                    toast.error('Coś poszło nie tak');
                });
        }
    });

    return (
        <div ref={scrollRef} className='vv-landing-page-vendor-form-container'>
            { !formSubmit ?
                <div className='vv-landing-page-vendor-form'>
                    <div className='vv-landing-page-vendor-form-container__headline'>
                        <h3>Zostań partnerem Viceversa</h3>
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <div className='vv-landing-page-vendor-form__input-container'>
                            <div className='vv-landing-page-vendor-form__margin'>
                                <Input label='Nazwa firmy' onBlur={formik.handleBlur} onChange={formik.handleChange}
                                       name='companyName' id='companyName'
                                       value={formik.values.companyName}
                                       textError={formik.touched.companyName && formik.errors.companyName}/>
                            </div>
                            <div className='vv-landing-page-vendor-form__margin'>
                                <Dropdown name='category' id='category' label='Branża'
                                          value={formik.values.category}
                                          onBlur={formik.handleBlur} onChange={(option) => formik.setFieldValue('category', option.value)}
                                          options={categories.map((category) => ({value: category.id, label: category.label}))}/>
                            </div>
                            <div className='vv-landing-page-vendor-form__margin'>
                                <TextArea label='W kilku zdaniach opisz swoje usługi'
                                          name='description' id='description'
                                          value={formik.values.description}
                                          onBlur={formik.handleBlur} onChange={formik.handleChange}
                                          textError={formik.touched.description && formik.errors.description}/>
                            </div>
                            <div className='vv-landing-page-vendor-form__input-container-city-nip'>
                                <div className='margin-right'>
                                    <Input label='Miasto' name='city' id='city'
                                           value={formik.values.city}
                                           onBlur={formik.handleBlur} onChange={formik.handleChange}
                                           textError={formik.touched.city && formik.errors.city}/>
                                </div>
                                <Input label='Nip' name='nip' id='nip'
                                       value={formik.values.nip}
                                       onBlur={formik.handleBlur} onChange={formik.handleChange}
                                       textError={formik.touched.nip && formik.errors.nip}/>
                            </div>
                            <div className='vv-landing-page-vendor-form__margin'>
                                <Input label='Imię i nazwisko do kontaktu' name='name' id='name'
                                       value={formik.values.name}
                                       onBlur={formik.handleBlur} onChange={formik.handleChange}
                                       textError={formik.touched.name && formik.errors.name}/>
                            </div>
                            <Input label='E-mail' name='email' id='email'
                                   onBlur={formik.handleBlur} onChange={formik.handleChange}
                                   textError={formik.touched.email && formik.errors.email}/>
                        </div>
                        <div className='vv-landing-page-vendor-form__checkbox'>
                            <InputCheckbox label='Zgody marketingowe'
                                           name='marketingPermission' id='marketingPermission'
                                           onChange={formik.handleChange}
                                           value={formik.values.marketingPermission}
                                           textError={formik.touched.marketingPermission && formik.errors.marketingPermission}/>
                        </div>
                        <div className='vv-landing-page-vendor-form__button'>
                            <Button size={ButtonSize.VENDOR} buttonType={ButtonType.PRIMARY} text='WYŚLIJ ZGŁOSZENIE'
                                    type='submit' onClick={formik.handleSubmit}/>
                        </div>
                    </form>
                </div>
                :
                <div className='vv-landing-page-vendor-form-container__info'>
                    <h3>Formularz wysłany!</h3>
                    <p>Będziemy w kontakcie</p>
                </div>
            }
        </div>
    );
};